var i = 6e4, n = 36e5;
export {
  n as millisecondsInHour,
  i as millisecondsInMinute
};
//# sourceMappingURL=index334.mjs.map
